import { z } from 'zod'

import { MinimumFile } from '@/modules/shared/schemas/MinimumFile'
import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

import { BelongLocation } from './BelongLocation'
import { BelongMomentStatus } from './BelongMomentStatus'
import { BelongStatus } from './BelongStatus'

export const DayBelongReport = z.object({
  types: z.array(
    z.object({
      status: BelongStatus,
      amount: z.number().int()
    })
  ),
  belongs: z
    .object({
      id: z.string(),
      status: BelongMomentStatus,
      statusItem: BelongStatus,
      date: z.string(),
      incomingTime: z.string(),
      outgoingTime: z.string(),
      preparingTime: z.string(),
      responsible: PersonaInfoSummary,
      observation: z.string(),
      belongItems: z.array(
        z.object({
          id: z.string(),
          date: z.string(),
          name: z.string(),
          status: BelongStatus,
          belongMoment: BelongMomentStatus,
          location: BelongLocation,
          reason: z.string().nullable(),
          file: MinimumFile
        })
      ),
      belongErrors: z.array(
        z.object({
          id: z.string(),
          date: z.string(),
          name: z.string(),
          status: BelongStatus,
          belongMoment: BelongMomentStatus,
          location: BelongLocation,
          reason: z.string(),
          file: MinimumFile,
          responsible: PersonaInfoSummary
        })
      )
    })
    .nullable(),
  responses: z.array(
    z.object({
      time: z.string(),
      types: z.array(
        z.object({
          status: BelongStatus,
          amount: z.number().int()
        })
      )
    })
  )
})
export type DayBelongReport = z.infer<typeof DayBelongReport>
